import React, { Fragment } from 'react'
import { List, Datagrid, Filter, ShowButton, TextInput, TextField, Button, EditButton,useRecordContext, BulkDeleteButton, FunctionField, DeleteButton } from 'react-admin'
import { ContentWriterStatusSelectInput } from '../../UI/Input/SelectInput'
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'
import { Link } from 'react-router-dom';


const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <ContentWriterStatusSelectInput label="Status" source="status" />
  </Filter>
)

const ProfileidFiled = (props) => {
  const record = useRecordContext();
  return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event) => event.stopPropagation()} />
  )
}
const ListActionButtons = ({ ...props }) => {
  return (<>
    <BulkDeleteButton {...props} undoable={false}
      confirmTitle="Delete File Record"
      confirmContent={"Are you sure you want to delete this record?"} />
  </>)
}
const RewardHistoryList = ({ ...props }) => {

  return (
    <List {...props} title="Reward History" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'name', order: 'ASC' }}>

      <Datagrid >
        <TextField source="id" />
        <ProfileidFiled source="profile_id" label="Profile Id" />
          <TextField label="Name" source="name" sortable={false} />
        <TextField label="Total Reward" source="total_earned_reward" sortable={false} />
        <TextField label="Downliner Count" source="downliner_count" sortable={false} />
      </Datagrid>

    </List>
  )
}

export default RewardHistoryList
